import React from 'react';

const VehicleSection = ({
  stats,
  handlePrintWarrantyReport
}) => {
  const style = {
    grid3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '25px', marginBottom: '30px' },
    grid2: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '25px' },
    card: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    kpiCard: { padding: '25px', borderRadius: '15px', color: 'white', display: 'flex', flexDirection: 'column', minHeight: '130px', justifyContent: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    kpiTitle: { fontSize: '13px', fontWeight: '700', opacity: 0.85, marginBottom: '10px', letterSpacing: '0.5px' },
    kpiValue: { fontSize: '26px', fontWeight: 'bold' },
    chartBarContainer: { background: '#f1f5f9', width: '100%', height: '16px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' },
    chartBarFill: (color, width) => ({ background: color, width: `${width}%`, height: '100%', transition: 'width 0.5s ease-in-out' }),
    innerFlexBetween: { display: 'flex', justifyContent: 'space-between', padding: '16px 12px', borderBottom: '1px solid #f1f5f9', fontSize: '14px', alignItems: 'center' },
    badge: (bg, text) => ({ background: bg, color: text, padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' }),
    btnPrintRow: { padding: '6px 12px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', fontSize: '11px', cursor: 'pointer', transition: '0.2s', boxShadow: '0 2px 6px rgba(59,130,246,0.15)' }
  };

  return (
    <>
      <div style={style.grid3}>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #1e293b, #0f172a)'}}>
          <div style={style.kpiTitle}>🚗 총 보유 및 유통 차량 마스터</div>
          <div style={style.kpiValue}>{stats.totalVehicles} 대</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #ef4444, #b91c1c)'}}>
          <div style={style.kpiTitle}>🚨 3개월 이내 보증만료 예정 차량</div>
          <div style={style.kpiValue}>{stats.warrantyData.expiringSoon} 대</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #64748b, #475569)'}}>
          <div style={style.kpiTitle}>⏳ 보증 만료 운행 차량 (유상 전환 대상)</div>
          <div style={style.kpiValue}>{stats.warrantyData.expired} 대</div>
        </div>
      </div>
          
      <div style={style.grid2}>
        <div style={style.card}>
          <h3 style={{margin: '0 0 15px 0', fontSize: '16px', color: '#1e293b'}}>🚗 모델별 포트폴리오 점유율 분석</h3>
          <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            {stats.modelData.map((item, index) => (
              <div key={index}>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '14px'}}>
                  <span><b>{item.name}</b> <span style={{color: '#64748b', fontSize: '12px'}}>({item.count}대)</span></span>
                  <span style={{color: '#1e293b', fontWeight: 'bold'}}>{item.percentage}%</span>
                </div>
                <div style={style.chartBarContainer}>
                  <div style={style.chartBarFill(index === 0 ? '#3b82f6' : index === 1 ? '#10b981' : '#64748b', item.percentage)}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={style.card}>
          <div style={{marginBottom:'20px'}}>
            <h3 style={{margin: 0, fontSize: '16px', color: '#1e293b'}}>🛡️ 보증기간 만료 케어 및 예측 시스템</h3>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '10px'}}>
            
            {/* 1. 3개월 도래 차량 */}
            <div style={style.innerFlexBetween}>
              <span style={style.badge('#fee2e2', '#ef4444')}>🚨 3개월 이내 보증만료 도래</span>
              <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                <span style={{fontWeight: '800', color: '#1e293b', fontSize: '15px'}}>{stats.warrantyData.expiringSoon} 대</span>
                <button onClick={() => handlePrintWarrantyReport('expiring')} style={style.btnPrintRow}>🖨️ 출력하기</button>
              </div>
            </div>

            {/* 2. 만료 완결 차량 */}
            <div style={style.innerFlexBetween}>
              <span style={style.badge('#f1f5f9', '#64748b')}>⏳ 보증기간 최종 만료 (유상 대상)</span>
              <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                <span style={{fontWeight: '800', color: '#1e293b', fontSize: '15px'}}>{stats.warrantyData.expired} 대</span>
                <button onClick={() => handlePrintWarrantyReport('expired')} style={style.btnPrintRow}>🖨️ 출력하기</button>
              </div>
            </div>

            {/* 3. 안정권 운행 차량 - 🚀 [교정 완료] 깨져있던 스타일 바인딩 오타를 지우고 깔끔하게 복구 완료 */}
            <div style={style.innerFlexBetween}>
              <span style={{...style.badge('#dcfce7', '#15803d'), whiteSpace:'nowrap'}}>✅ 보증기간 안정권 운행 차량</span>
              <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                <span style={{fontWeight: '800', color: '#1e293b', fontSize: '15px'}}>{stats.warrantyData.active} 대</span>
                <button onClick={() => handlePrintWarrantyReport('active')} style={style.btnPrintRow}>🖨️ 출력하기</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleSection;